import React, { useMemo, useEffect } from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { fetchFranchiseType } from "services/dropdown";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { Controller } from "react-hook-form";
import { useSelector } from "react-redux";

const Franchise = ({
  errors,
  control,
  setValue,
  getValues,
  watch,
  rowData,
  required,
}) => {
  const franchiseName = rowData?.franchise_obj
    ? rowData.franchise_obj.franchise_type
    : rowData?.franchise_type
      ? rowData.franchise_type
      : getValues().franchise_type;

  const selectedFranchiseId = watch("franchise_type_id");
  const login = useSelector((state) => state.jwtAuthreducer);

  const {
    data: franchiseTypeList,
    isLoading,
    error,
    refetch,
  } = useQuery(["Franchise"], () => fetchFranchiseType({ ...login }), {
    keepPreviousData: false,
    staleTime: DROPDOWN_STALE_TIME,
  });

  useEffect(() => {
    refetch()
  }, login)

  const modifiedData = useMemo(() => {
    return (
      franchiseTypeList?.data?.data?.map((ele) => ({
        value: ele.id,
        label: ele.franchise_type,
      })) || []
    );
  }, [franchiseTypeList]);

  const options = useMemo(() => modifiedData, [modifiedData]);

  const selectedOption = useMemo(() => {
    return (
      options.find((option) => option.value === selectedFranchiseId) ||
      options.find((option) => option.label === franchiseName) ||
      null
    );
  }, [options, selectedFranchiseId, franchiseName]);

  // useEffect(() => {
  //   if (rowData && options.length) {
  //     const rowDataOption = options.find(
  //       (option) => option.value === rowData?.franchise_type || 4
  //     );
  //     setValue("franchise_type_id", rowDataOption?.value);
  //     setValue("franchise_type", rowDataOption?.label);
  //   }
  // }, [rowData, options, setValue]);

  useEffect(() => {
    if (options.length) {
      let selected = null;

      if (rowData) {
        selected =
          options.find((option) => option.value === rowData?.franchise_type) ||
          options.find((option) => option.label === rowData?.franchise_obj?.franchise_type);
      } else {
        selected = options.find((option) => option.value === 4);
      }

      if (selected) {
        setValue("franchise_type_id", selected.value);
        setValue("franchise_type", selected.label);
      }
    }
  }, [rowData, options, setValue]);

  useEffect(() => {
    if (selectedOption) {
      setValue("franchise_type_id", selectedOption.value);
      setValue("franchise_type", selectedOption.label);
    }
  }, [selectedOption, setValue]);

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading Franchise Type</div>;

  return (
    <>
      <Controller
        name="franchise_type_id"
        control={control}
        rules={{
          required: required ? "Franchise is required" : false,
          validate: (value) => {
            if (required && !value) return "Franchise is required";
            return true;
          },
        }}
        render={({ field }) => (
          <Select
            {...field}
            options={options}
            isClearable
            value={selectedOption || null}
            placeholder="Select Franchise Type"
            menuPortalTarget={document.body}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
            onChange={(selectedOption) => {
              const value = selectedOption ? selectedOption.value : "";
              field.onChange(value);
              setValue("franchise_type_id", value);
              setValue(
                "franchise_type",
                selectedOption ? selectedOption.label : ""
              );
            }}
            className={`react-select-container ${errors.franchise_type_id ? "is-invalid" : ""
              }`}
          />
        )}
      />
      {errors.franchise_type_id && (
        <div className="invalid-feedback">
          {errors.franchise_type_id.message}
        </div>
      )}
    </>
  );
};

export default Franchise;
